
import WeaLocaleProvider from '../wea-locale-provider';
const getLabel = WeaLocaleProvider.getLabel;

const render = (_idArray, _nameArray, _jobtitleArray, __x, __y) => {
  var browgroupHtml = '';
  var _i;
  for (_i = 0; _i < _idArray.length; _i++) {
    var className = (_i % 2 == 1 ? 'ac_even' : 'ac_odd');
    var displaycss = _i > 4 ? ' display:none; ' : '';
    var resdetailinfohtml = "<span style='display:inline-block;width:80px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;'><a href=javaScript:openhrm(" + _idArray[_i] + "); onclick='pointerXY(event);' style='overflow: hidden;white-space: nowrap;text-overflow: ellipsis;' title='" + _nameArray[_i] + "'>" + _nameArray[_i] + '</a></span>';
    resdetailinfohtml += "<span style='float:right;display:inline-block;width:130px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;' title='" + _jobtitleArray[_i] + "'>" + _jobtitleArray[_i] + '</span>';

    browgroupHtml += '<li class="' + className + '" _id="' + _idArray[_i] + '" style=\'' + displaycss + '\'>' + resdetailinfohtml + '</li>';


    if (_i > 4 && _i == _idArray.length - 1) {
      browgroupHtml += '<li class="' + className + '" title="' + getLabel(20234, "显示全部") + '" style="text-align:center;" onclick="showallCrmsdetail(this);">' + getLabel(20234, "显示全部") + '</li>';
    }
  }

  if (!!browgroupHtml) {
    var autoCompleteDiv = jQuery("<div id='__brow__detaildiv' class='wea-hrmgroup-wrapper' style=\"position:absolute;width:245px;z-index:1099;left:" + __x + 'px;top:' + __y + 'px;"></div>');
    var autoCompleteDiv_html = jQuery('<div class="arrowsblock"><img src="/images/ecology8/workflow/multres/arrows_2_wev8.png" width="22px" height="22px"></div>'
            + "<div class='ac_results' style='margin-top:20px;background:#fff;z-index:9;'><ul>" + browgroupHtml + '</ul></div>'
        );
    var mask = jQuery("<div id='__brow__detaildiv_mask' onclick='closeCrmsDetail();' style=\"position:fixed; top:0;left:0;right:0;bottom:0; z-index:1098;\"></div>");
    autoCompleteDiv.append(autoCompleteDiv_html);
        // autoCompleteDiv_html.addClass("ac_results");
    jQuery('body').append(mask).append(autoCompleteDiv);
  }
};

window.showCrmsDetail = (e, params = {}) => {
  closeCrmsDetail();
  const target = jQuery(e.target);
  let x = target.offset().left - (245 - target.width()) / 2;
  let y = target.offset().top + 15;
  render(params.ids, params.names, params.jobtitles, x, y);
};

window.closeCrmsDetail = () => {
  jQuery('#__brow__detaildiv_mask').remove();
  jQuery('#__brow__detaildiv').remove();
};

window.showallCrmsdetail = (ele) => {
  var target = jQuery(ele);
  var parentDiv = target.closest('div');
  parentDiv.css({
    'height': parentDiv.height() + 'px',
    'overflow': 'auto',
  });

    // parentDiv.perfectScrollbar({horizrailenabled:false,zindex:1000});

  var othli = target.parent().children().not(':visible');
  othli.show();
  target.hide();
};


// WEBPACK FOOTER //
// ./ecology9/wea-tools/hrmBrowserUtil.js